export default __webpack_public_path__ + "static/screen_1_05-7c8064f37f0a917833aa3cee4f47a3fa.svg";